import React, { useEffect, useMemo } from 'react';
import { useSingleEffect } from 'react-haiku';
import { useCollect } from 'hooks';

import { Title } from 'components/Misc/Typography';

import All from 'containers/Student/Webinars/Read/All';
import Active from 'containers/Student/Webinars/Read/Active';

import { useAppStore } from 'store/useAppStore';
import { useStudentWebinarStore } from 'store/student/useStudentWebinarStore';

const Read = () => {
	// Use app's store
	const setTitle = useAppStore(state => state.setTitle);

	// Use student's webinar store
	const [onInit, onReset] = useStudentWebinarStore(state => [
		state.onInit,
		state.onReset
	]);

	// Set app's title on mount
	useSingleEffect(() => setTitle('Vebināri'));

	// Store request parameters
	const parameters = useMemo(() => ({
		eager: '[subject, course]',
		type: 'online'
	}), []);

	// Store requested webinars
	const [[result, progress], collect] = useCollect('webinars', parameters);

	// Collect webinars on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	// Initialize webinar's data after collection
	useEffect(() => {
		if (result) onInit(result);

		// Reset webinar's data on unmount
		return () => onReset();
	}, [result]);

	return (
		<div className="space-y-4">
			<Title
				title="Vebināri"
				className="text-2xl"
			/>
			
			{/* Show closest webinars */}
			<Active progress={progress} />

			{/* Show active grade's webinars */}
			<All progress={progress} />
		</div>
	);
};

export default Read;